// extracted by mini-css-extract-plugin
export default {"footer_wrapper":"Footer_footer_wrapper__rwu2B","footer_middle":"Footer_footer_middle__1fffy"};